import React, { Suspense, useEffect, useState, useRef } from 'react'
import './index.scss'
import { Row, Input, Col, Table, Divider } from 'antd'
import { getQueryAnalyze, getQueryTranslate, getQueryJargonRules } from '../../services/catalogSearchService'
// import ReactJson from 'react-json-view'

const { Search } = Input
const tokenColumns = [{
  title: 'Token',
  key: 'token',
  dataIndex: 'token',
}, {
  title: 'Type',
  key: 'type',
  dataIndex: 'type',
}, {
  title: 'Position',
  key: 'position',
  dataIndex: 'position',
}, {
  title: 'Start Offset',
  key: 'start_offset',
  dataIndex: 'start_offset',
}, {
  title: 'End Offset',
  key: 'end_offset',
  dataIndex: 'end_offset',
}]

const ReactJson = React.lazy(() => import('react-json-view'))

function QueryTester() {
  const [result, setResult] = useState<any>()
  const [jargonRules, setJargonRules] = useState<any>()
  const [query, setQuery] = useState('')

  useEffect(() => {
    if (!query) return
    getQueryAnalyze(query)
      .then(res => {
        if (res.data) {
          console.log(res.data)
          setResult(res.data)
        }
      })
      .catch(err => {
        console.error(err)
      })

    // getQueryTranslate(query)
    //   .then(res => {
    //     if (res.data) {
    //       console.log(res.data)
    //       // setResult(res.data)
    //     }
    //   })
    //   .catch(err => {
    //     console.error(err)
    //   })
    getQueryJargonRules(query)
    .then(res => {
      if (res.data) {
        console.log(res.data)
        setJargonRules(res.data)
      }
    })
    .catch(err => {
      console.error(err)
    })
  }, [query])

  const onSearch = (v: string) => {
    setQuery(v)
  }

  return (
    <div className='qt-container'>
      <Row gutter={2}>
        <Col span={6}>
          <Search addonBefore="搜索词" size="large" enterButton allowClear onSearch={onSearch} />
        </Col>
      </Row>
      <Divider />
      <div>
        <p><strong>Analyze</strong></p>
        <Table columns={tokenColumns} pagination={false} dataSource={result?.tokens || []} />
      </div>
      {jargonRules ? (
        <>
          <Divider />
          <Suspense fallback={<div />}>
            <div>
              <p><strong>Jargon Rules</strong></p>
              <ReactJson src={jargonRules} displayDataTypes={false} displayObjectSize={false} enableClipboard={false} collapsed={3} />
            </div>
          </Suspense>
        </>
      ) : null}
    </div>
  )
}

export default QueryTester
